import React from "react";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../index";
import { msalConfig } from '../authConfig';
import { PublicClientApplication } from '@azure/msal-browser';
import { AuthenticatedTemplate, UnauthenticatedTemplate, } from '@azure/msal-react';
import Button from 'react-bootstrap/Button';

import './NavMenu.css';

export const SignIn = () => {
    const { instance } = useMsal();
    /*const myMSALObj = new PublicClientApplication(msalConfig);*/

    const handleLogin = (e) => {
        instance.loginRedirect(loginRequest);
        /* myMSALObj.loginRedirect(loginRequest);*/
        /*console.log("Hello world")*/
        console.log(e);
    };

    return (
        <div id="Login">
            <input type="submit" value="Sign In" className="btn" style={{ backgroundColor: "#563abe", color: "#ffffff", fontSize: "1.2rem", fontWeight: "600", marginLeft: "1vh" }} onClick={handleLogin} />

        {/*    <a className="btn btn-info bg-white text-dark" role="button" onClick={handleLogin} >Sign In</a>*/}
        </div>

    );
}